// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.issue_backdrop__6omgh {
  position: fixed;
  top: 52px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 29;
  cursor: pointer;
}

.issue_drawer__IZchG {
  position: fixed;
  top: 52px;
  right: 0;
  bottom: 0;
  width: min(680px, 96vw);
  background: var(--bg-raised);
  border-left: 2px solid var(--highlight-color);
  z-index: 30;
  display: flex;
  flex-direction: column;
}
.issue_drawer__IZchG .issue_drawerHeader__WvOgD {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-default);
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.issue_drawer__IZchG .issue_drawerHeader__WvOgD .issue_breadcrumbs__VMJ98 {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 12px;
  margin-bottom: 6px;
}
.issue_drawer__IZchG .issue_drawerHeader__WvOgD .issue_close__ROEJ3 {
  background: transparent;
  border: none;
  color: var(--text-strong);
  border-radius: 8px;
  cursor: pointer;
  padding: 2px 8px;
  font-size: 16px;
  line-height: 1;
}
.issue_drawer__IZchG .issue_drawerHeader__WvOgD .issue_close__ROEJ3 .issue_closeIcon__7q0el {
  filter: var(--text-muted-filter);
}
.issue_drawer__IZchG .issue_drawerHeader__WvOgD .issue_close__ROEJ3 .issue_closeIcon__7q0el:hover {
  filter: var(--text-primary-filter);
}

.issue_backLink__I884Q {
  color: var(--text-body);
  text-decoration: none;
}

.issue_backLink__I884Q:hover {
  color: var(--text-heading);
}

.issue_sep__VWgqV {
  opacity: 0.6;
}

.issue_crumb__jLQIl {
  color: var(--text-strong);
}

.issue_title__GTqK2 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-heading);
  text-wrap: wrap;
}

.issue_meta__RwHpD {
  display: flex;
  gap: 10px;
  align-items: center;
}

.issue_createdBy__1qK5t {
  font-size: 12px;
  color: var(--text-tertiary);
}
.issue_createdBy__1qK5t strong {
  color: var(--text-strong);
  font-weight: 500;
}

.issue_pill__rJghh {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--fill-default);
  border: 1px solid var(--border-moderate);
  color: var(--text-strong);
}

.issue_link__W7LeJ {
  color: var(--text-muted);
  text-decoration: none;
  font-size: 12px;
}

.issue_link__W7LeJ:hover {
  text-decoration: underline;
}

.issue_drawerBody__fofFG {
  padding: 14px 16px 18px;
  overflow: auto;
}

.issue_section__uLaZn {
  padding-block: 1rem;
}

.issue_sectionTitle__UuBoB {
  font-size: 12px;
  color: var(--text-primary);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.issue_description__-H5dv {
  font-size: 13px;
  line-height: 1.5;
  border: 1px solid var(--highlight-color);
  border-radius: 10px;
  background: var(--fill-subtle);
  padding: 10px 10px;
  min-height: 3rem;
}
.issue_description__-H5dv p {
  margin: 0 0 0.5rem;
}
.issue_description__-H5dv p:last-child {
  margin-bottom: 0;
}
.issue_description__-H5dv ul,
.issue_description__-H5dv ol {
  margin: 0.25rem 0 0.5rem 1.25rem;
  padding: 0;
}
.issue_description__-H5dv li {
  margin: 0.15rem 0;
}
.issue_description__-H5dv a {
  color: var(--primary);
  text-decoration: underline;
}
.issue_description__-H5dv hr {
  border: 0;
  border-top: 1px solid var(--border-medium);
  margin: 0.75rem 0;
}
.issue_description__-H5dv blockquote {
  margin: 0.5rem 0;
  padding-left: 0.75rem;
  border-left: 3px solid var(--border-medium);
  color: var(--text-body);
}
.issue_description__-H5dv code {
  font-family: ui-monospace, SFMono-Regular, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.95em;
  background: var(--fill-default);
  border: 1px solid var(--border-moderate);
  padding: 0.1rem 0.25rem;
  border-radius: 6px;
}
.issue_description__-H5dv pre {
  margin: 0.5rem 0;
  padding: 0.75rem;
  background: var(--fill-light);
  border: 1px solid var(--border-default);
  border-radius: 10px;
  overflow: auto;
  white-space: pre;
}
.issue_description__-H5dv pre code {
  background: transparent;
  border: none;
  padding: 0;
  font-size: 0.9em;
}

.issue_attachmentsGrid__ARpGp {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  margin-top: 8px;
}

.issue_attachmentItem__Mep3T {
  background: var(--fill-subtle);
  border: 1px solid var(--highlight-color);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: transform 0.15s ease, border-color 0.15s ease;
}
.issue_attachmentItem__Mep3T:hover {
  transform: translateY(-2px);
  border-color: var(--border-strong);
  background: var(--fill-light);
}
.issue_attachmentItem__Mep3T:hover .issue_attachmentLabel__v79l6 {
  white-space: normal;
  word-break: break-all;
  color: var(--text-heading);
}

.issue_viewerContent__Dy7-W {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
}
.issue_viewerContent__Dy7-W img {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 4px;
  object-fit: contain;
}

.issue_attachmentPreview__8hU80 {
  width: 100%;
  aspect-ratio: 16/10;
  object-fit: cover;
  background: var(--bg-inset);
  display: block;
}

.issue_attachmentLabel__v79l6 {
  padding: 8px 10px;
  font-size: 11px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  border-top: 1px solid var(--fill-light);
}

.issue_comments__C5Tgx {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.issue_comment__kWPRp {
  padding: 10px 10px;
  border: 1px solid var(--highlight-color);
  border-radius: 10px;
  background: var(--fill-subtle);
}

.issue_commentHeader__Xjo9Z {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  margin-bottom: 1rem;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border-default);
}

.issue_commentAuthor__lHK6l {
  color: var(--text-primary);
  font-weight: 600;
  padding-bottom: 0.4rem;
}

.issue_commentTime__Uq2V5 {
  opacity: 0.8;
}

.issue_commentBody__w2XRB {
  font-size: 13px;
  line-height: 1.5;
}
.issue_commentBody__w2XRB p {
  margin: 0 0 0.5rem;
}
.issue_commentBody__w2XRB p:last-child {
  margin-bottom: 0;
}
.issue_commentBody__w2XRB ul,
.issue_commentBody__w2XRB ol {
  margin: 0.25rem 0 0.5rem 1.25rem;
  padding: 0;
}
.issue_commentBody__w2XRB li {
  margin: 0.15rem 0;
}
.issue_commentBody__w2XRB a {
  color: var(--primary);
  text-decoration: underline;
}
.issue_commentBody__w2XRB hr {
  border: 0;
  border-top: 1px solid var(--border-medium);
  margin: 0.75rem 0;
}
.issue_commentBody__w2XRB blockquote {
  margin: 0.5rem 0;
  padding-left: 0.75rem;
  border-left: 3px solid var(--border-medium);
  color: var(--text-body);
}
.issue_commentBody__w2XRB code {
  font-family: ui-monospace, SFMono-Regular, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.95em;
  background: var(--fill-default);
  border: 1px solid var(--border-moderate);
  padding: 0.1rem 0.25rem;
  border-radius: 6px;
}
.issue_commentBody__w2XRB pre {
  margin: 0.5rem 0;
  padding: 0.75rem;
  background: var(--fill-light);
  border: 1px solid var(--border-default);
  border-radius: 10px;
  overflow: auto;
  white-space: pre;
}
.issue_commentBody__w2XRB pre code {
  background: transparent;
  border: none;
  padding: 0;
  font-size: 0.9em;
}

.issue_textarea__l1Z9J {
  width: 100%;
  background: transparent;
  border: none;
  color: var(--text-primary);
  font-family: inherit;
  font-size: 14px;
  resize: none;
  outline: none;
  padding-right: 30px;
  margin-bottom: 8px;
}

.issue_composerAttachmentsBox__6ozUJ {
  background: var(--bg-inset);
  border: 1px solid var(--fill-light);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 12px;
}

.issue_attachmentsHeader__pFB-x {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-faint);
  margin-bottom: 8px;
}

.issue_composerFiles__-Hnax {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.issue_composerFileItem__l0A8M {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--fill-default);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  color: var(--text-strong);
  border: 1px solid var(--fill-light);
}

.issue_removeFile__Qe68X {
  background: none;
  border: none;
  color: var(--text-faint);
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  font-size: 10px;
}
.issue_removeFile__Qe68X:hover {
  color: var(--color-error-hover);
}

.issue_composerActions__0autS {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.issue_removeFile__Qe68X {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 0;
  line-height: 1;
}
.issue_removeFile__Qe68X:hover {
  color: var(--color-error-hover);
}

.issue_composerActions__0autS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}
.issue_composerActions__0autS .issue_fileLabel__CvtaM {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  transition: background 0.15s ease;
}
.issue_composerActions__0autS .issue_fileLabel__CvtaM .issue_paperClipIcon__-mLZl {
  width: 20px;
  height: 20px;
  filter: var(--text-muted-filter);
}
.issue_composerActions__0autS .issue_fileLabel__CvtaM .issue_paperClipIcon__-mLZl:hover {
  filter: var(--text-primary-filter);
}

.issue_textarea__l1Z9J {
  width: 100%;
  resize: none;
  min-height: 80px;
  background: var(--bg-topbar);
  border: 1px solid var(--highlight-color);
  border-radius: 10px;
  padding: 10px;
  color: var(--text-muted);
  font-size: 14px;
  outline: none;
  margin-block: 1rem;
}

.issue_textarea__l1Z9J:focus {
  border-color: var(--border-focus);
}

.issue_composerActions__0autS {
  display: flex;
  justify-content: flex-end;
}

.issue_button__FsxLC {
  background: var(--fill-default);
  border: 1px solid var(--border-moderate);
  color: var(--text-primary);
  border-radius: 10px;
  padding: 7px 10px;
  font-size: 12px;
  cursor: pointer;
}

.issue_button__FsxLC:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.issue_button__FsxLC:hover:enabled {
  background: var(--fill-hover);
}

.issue_muted__8H97o {
  color: var(--text-secondary);
  font-size: 13px;
}

.issue_error__5ncmb {
  color: var(--color-error);
  padding: 10px 16px 0;
  font-size: 13px;
}

.issue_loadingContainer__4vwQT {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  width: 100%;
  height: 100%;
  padding: 40px;
}

.issue_spinner__QgaCa {
  width: 40px;
  height: 40px;
  border: 3px solid var(--spinner-track);
  border-radius: 50%;
  border-top-color: var(--primary);
  animation: issue_spin__bPIL4 1s ease-in-out infinite;
}

@keyframes issue_spin__bPIL4 {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/internal/styles/issue.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,4BAAA;EACA,6CAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;AACN;AAEI;EACE,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAN;AAEM;EACE,gCAAA;AAAR;AAGM;EACE,kCAAA;AADR;;AAOA;EACE,uBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAJF;;AAOA;EACE,eAAA;EACA,2BAAA;AAJF;AAME;EACE,yBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,wCAAA;EACA,yBAAA;AALF;;AAQA;EACE,wBAAA;EACA,qBAAA;EACA,eAAA;AALF;;AAQA;EACE,0BAAA;AALF;;AAQA;EACE,uBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AALF;AAOE;EACE,kBAAA;AALJ;AAQE;EACE,gBAAA;AANJ;AASE;;EAEE,gCAAA;EACA,UAAA;AAPJ;AAUE;EACE,iBAAA;AARJ;AAWE;EACE,qBAAA;EACA,0BAAA;AATJ;AAYE;EACE,SAAA;EACA,0CAAA;EACA,iBAAA;AAVJ;AAaE;EACE,gBAAA;EACA,qBAAA;EACA,2CAAA;EACA,uBAAA;AAXJ;AAcE;EACE,+HACE;EAEF,iBAAA;EACA,+BAAA;EACA,wCAAA;EACA,uBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,8BAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,yDACE;AAlBJ;AAqBE;EACE,2BAAA;EACA,kCAAA;EACA,6BAAA;AAnBJ;AAqBI;EACE,mBAAA;EACA,qBAAA;EACA,0BAAA;AAnBN;;AAwBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AArBF;AAuBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AArBJ;;AAyBA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uCAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,8BAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,8CAAA;AAtBF;;AAyBA;EACE,0BAAA;EACA,gBAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,YAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,gBAAA;AAtBF;AAwBE;EACE,kBAAA;AAtBJ;AAyBE;EACE,gBAAA;AAvBJ;AA0BE;;EAEE,gCAAA;EACA,UAAA;AAxBJ;AA2BE;EACE,iBAAA;AAzBJ;AA4BE;EACE,qBAAA;EACA,0BAAA;AA1BJ;AA6BE;EACE,SAAA;EACA,0CAAA;EACA,iBAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,qBAAA;EACA,2CAAA;EACA,uBAAA;AA5BJ;AA+BE;EACE,+HACE;EAEF,iBAAA;EACA,+BAAA;EACA,wCAAA;EACA,uBAAA;EACA,kBAAA;AA/BJ;AAkCE;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAhCJ;AAmCE;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAjCJ;;AAqCA;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,2BAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAlCF;;AAqCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mCAAA;AAlCF;;AAqCA;EACE,gBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAlCF;AAoCE;EACE,+BAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AAnCF;AAoCE;EACE,+BAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAnCF;AAqCE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AAnCJ;AAqCI;EACE,WAAA;EACA,YAAA;EACA,gCAAA;AAnCN;AAqCM;EACE,kCAAA;AAnCR;;AAyCA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAtCF;;AAyCA;EACE,iCAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,yBAAA;AAtCF;;AAyCA;EACE,+BAAA;EACA,wCAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,mBAAA;AAtCF;;AAyCA;EACE,6BAAA;AAtCF;;AAyCA;EACE,4BAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,yBAAA;EACA,oBAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,gCAAA;EACA,oDAAA;AAtCF;;AAyCA;EACE;IACE,yBAAA;EAtCF;AACF","sourcesContent":[".backdrop {\n  position: fixed;\n  top: 52px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 29;\n  cursor: pointer;\n}\n\n.drawer {\n  position: fixed;\n  top: 52px;\n  right: 0;\n  bottom: 0;\n  width: min(680px, 96vw);\n  background: var(--bg-raised);\n  border-left: 2px solid var(--highlight-color);\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n\n  .drawerHeader {\n    padding: 14px 16px;\n    border-bottom: 1px solid var(--border-default);\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n\n    .breadcrumbs {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: var(--text-secondary);\n      font-size: 12px;\n      margin-bottom: 6px;\n    }\n\n    .close {\n      background: transparent;\n      border: none;\n      color: var(--text-strong);\n      border-radius: 8px;\n      cursor: pointer;\n      padding: 2px 8px;\n      font-size: 16px;\n      line-height: 1;\n\n      .closeIcon {\n        filter: var(--text-muted-filter);\n      }\n\n      .closeIcon:hover {\n        filter: var(--text-primary-filter);\n      }\n    }\n  }\n}\n\n.backLink {\n  color: var(--text-body);\n  text-decoration: none;\n}\n\n.backLink:hover {\n  color: var(--text-heading);\n}\n\n.sep {\n  opacity: 0.6;\n}\n\n.crumb {\n  color: var(--text-strong);\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-heading);\n  text-wrap: wrap;\n}\n\n.meta {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.createdBy {\n  font-size: 12px;\n  color: var(--text-tertiary);\n\n  strong {\n    color: var(--text-strong);\n    font-weight: 500;\n  }\n}\n\n.pill {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--fill-default);\n  border: 1px solid var(--border-moderate);\n  color: var(--text-strong);\n}\n\n.link {\n  color: var(--text-muted);\n  text-decoration: none;\n  font-size: 12px;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n.drawerBody {\n  padding: 14px 16px 18px;\n  overflow: auto;\n}\n\n.section {\n  padding-block: 1rem;\n}\n\n.sectionTitle {\n  font-size: 12px;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.description {\n  font-size: 13px;\n  line-height: 1.5;\n  border: 1px solid var(--highlight-color);\n  border-radius: 10px;\n  background: var(--fill-subtle);\n  padding: 10px 10px;\n  min-height: 3rem;\n\n  p {\n    margin: 0 0 0.5rem;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  ul,\n  ol {\n    margin: 0.25rem 0 0.5rem 1.25rem;\n    padding: 0;\n  }\n\n  li {\n    margin: 0.15rem 0;\n  }\n\n  a {\n    color: var(--primary);\n    text-decoration: underline;\n  }\n\n  hr {\n    border: 0;\n    border-top: 1px solid var(--border-medium);\n    margin: 0.75rem 0;\n  }\n\n  blockquote {\n    margin: 0.5rem 0;\n    padding-left: 0.75rem;\n    border-left: 3px solid var(--border-medium);\n    color: var(--text-body);\n  }\n\n  code {\n    font-family:\n      ui-monospace, SFMono-Regular, SFMono-Regular, Menlo, Monaco, Consolas,\n      \"Liberation Mono\", \"Courier New\", monospace;\n    font-size: 0.95em;\n    background: var(--fill-default);\n    border: 1px solid var(--border-moderate);\n    padding: 0.1rem 0.25rem;\n    border-radius: 6px;\n  }\n\n  pre {\n    margin: 0.5rem 0;\n    padding: 0.75rem;\n    background: var(--fill-light);\n    border: 1px solid var(--border-default);\n    border-radius: 10px;\n    overflow: auto;\n    white-space: pre;\n  }\n\n  pre code {\n    background: transparent;\n    border: none;\n    padding: 0;\n    font-size: 0.9em;\n  }\n}\n\n.attachmentsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.attachmentItem {\n  background: var(--fill-subtle);\n  border: 1px solid var(--highlight-color);\n  border-radius: 10px;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  transition:\n    transform 0.15s ease,\n    border-color 0.15s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    border-color: var(--border-strong);\n    background: var(--fill-light);\n\n    .attachmentLabel {\n      white-space: normal;\n      word-break: break-all;\n      color: var(--text-heading);\n    }\n  }\n}\n\n.viewerContent {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n\n  img {\n    max-width: 100%;\n    max-height: 80vh;\n    border-radius: 4px;\n    object-fit: contain;\n  }\n}\n\n.attachmentPreview {\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  object-fit: cover;\n  background: var(--bg-inset);\n  display: block;\n}\n\n.attachmentLabel {\n  padding: 8px 10px;\n  font-size: 11px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  border-top: 1px solid var(--fill-light);\n}\n\n.comments {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.comment {\n  padding: 10px 10px;\n  border: 1px solid var(--highlight-color);\n  border-radius: 10px;\n  background: var(--fill-subtle);\n}\n\n.commentHeader {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 12px;\n  margin-bottom: 1rem;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border-default);\n}\n\n.commentAuthor {\n  color: var(--text-primary);\n  font-weight: 600;\n  padding-bottom: 0.4rem;\n}\n\n.commentTime {\n  opacity: 0.8;\n}\n\n.commentBody {\n  font-size: 13px;\n  line-height: 1.5;\n\n  p {\n    margin: 0 0 0.5rem;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  ul,\n  ol {\n    margin: 0.25rem 0 0.5rem 1.25rem;\n    padding: 0;\n  }\n\n  li {\n    margin: 0.15rem 0;\n  }\n\n  a {\n    color: var(--primary);\n    text-decoration: underline;\n  }\n\n  hr {\n    border: 0;\n    border-top: 1px solid var(--border-medium);\n    margin: 0.75rem 0;\n  }\n\n  blockquote {\n    margin: 0.5rem 0;\n    padding-left: 0.75rem;\n    border-left: 3px solid var(--border-medium);\n    color: var(--text-body);\n  }\n\n  code {\n    font-family:\n      ui-monospace, SFMono-Regular, SFMono-Regular, Menlo, Monaco, Consolas,\n      \"Liberation Mono\", \"Courier New\", monospace;\n    font-size: 0.95em;\n    background: var(--fill-default);\n    border: 1px solid var(--border-moderate);\n    padding: 0.1rem 0.25rem;\n    border-radius: 6px;\n  }\n\n  pre {\n    margin: 0.5rem 0;\n    padding: 0.75rem;\n    background: var(--fill-light);\n    border: 1px solid var(--border-default);\n    border-radius: 10px;\n    overflow: auto;\n    white-space: pre;\n  }\n\n  pre code {\n    background: transparent;\n    border: none;\n    padding: 0;\n    font-size: 0.9em;\n  }\n}\n\n.textarea {\n  width: 100%;\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  font-family: inherit;\n  font-size: 14px;\n  resize: none;\n  outline: none;\n  padding-right: 30px; // Space for the paperclip\n  margin-bottom: 8px;\n}\n\n.composerAttachmentsBox {\n  background: var(--bg-inset);\n  border: 1px solid var(--fill-light);\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 12px;\n}\n\n.attachmentsHeader {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-faint);\n  margin-bottom: 8px;\n}\n\n.composerFiles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.composerFileItem {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--fill-default);\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  color: var(--text-strong);\n  border: 1px solid var(--fill-light);\n}\n\n.removeFile {\n  background: none;\n  border: none;\n  color: var(--text-faint);\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  font-size: 10px;\n\n  &:hover {\n    color: var(--color-error-hover);\n  }\n}\n\n.composerActions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.removeFile {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  &:hover {\n    color: var(--color-error-hover);\n  }\n}\n\n.composerActions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 4px;\n\n  .fileLabel {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 6px;\n    transition: background 0.15s ease;\n\n    .paperClipIcon {\n      width: 20px;\n      height: 20px;\n      filter: var(--text-muted-filter);\n\n      &:hover {\n        filter: var(--text-primary-filter);\n      }\n    }\n  }\n}\n\n.textarea {\n  width: 100%;\n  resize: none;\n  min-height: 80px;\n  background: var(--bg-topbar);\n  border: 1px solid var(--highlight-color);\n  border-radius: 10px;\n  padding: 10px;\n  color: var(--text-muted);\n  font-size: 14px;\n  outline: none;\n  margin-block: 1rem;\n}\n\n.textarea:focus {\n  border-color: var(--border-focus);\n}\n\n.composerActions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button {\n  background: var(--fill-default);\n  border: 1px solid var(--border-moderate);\n  color: var(--text-primary);\n  border-radius: 10px;\n  padding: 7px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.button:hover:enabled {\n  background: var(--fill-hover);\n}\n\n.muted {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.error {\n  color: var(--color-error);\n  padding: 10px 16px 0;\n  font-size: 13px;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--spinner-track);\n  border-radius: 50%;\n  border-top-color: var(--primary);\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `issue_backdrop__6omgh`,
	"drawer": `issue_drawer__IZchG`,
	"drawerHeader": `issue_drawerHeader__WvOgD`,
	"breadcrumbs": `issue_breadcrumbs__VMJ98`,
	"close": `issue_close__ROEJ3`,
	"closeIcon": `issue_closeIcon__7q0el`,
	"backLink": `issue_backLink__I884Q`,
	"sep": `issue_sep__VWgqV`,
	"crumb": `issue_crumb__jLQIl`,
	"title": `issue_title__GTqK2`,
	"meta": `issue_meta__RwHpD`,
	"createdBy": `issue_createdBy__1qK5t`,
	"pill": `issue_pill__rJghh`,
	"link": `issue_link__W7LeJ`,
	"drawerBody": `issue_drawerBody__fofFG`,
	"section": `issue_section__uLaZn`,
	"sectionTitle": `issue_sectionTitle__UuBoB`,
	"description": `issue_description__-H5dv`,
	"attachmentsGrid": `issue_attachmentsGrid__ARpGp`,
	"attachmentItem": `issue_attachmentItem__Mep3T`,
	"attachmentLabel": `issue_attachmentLabel__v79l6`,
	"viewerContent": `issue_viewerContent__Dy7-W`,
	"attachmentPreview": `issue_attachmentPreview__8hU80`,
	"comments": `issue_comments__C5Tgx`,
	"comment": `issue_comment__kWPRp`,
	"commentHeader": `issue_commentHeader__Xjo9Z`,
	"commentAuthor": `issue_commentAuthor__lHK6l`,
	"commentTime": `issue_commentTime__Uq2V5`,
	"commentBody": `issue_commentBody__w2XRB`,
	"textarea": `issue_textarea__l1Z9J`,
	"composerAttachmentsBox": `issue_composerAttachmentsBox__6ozUJ`,
	"attachmentsHeader": `issue_attachmentsHeader__pFB-x`,
	"composerFiles": `issue_composerFiles__-Hnax`,
	"composerFileItem": `issue_composerFileItem__l0A8M`,
	"removeFile": `issue_removeFile__Qe68X`,
	"composerActions": `issue_composerActions__0autS`,
	"fileLabel": `issue_fileLabel__CvtaM`,
	"paperClipIcon": `issue_paperClipIcon__-mLZl`,
	"button": `issue_button__FsxLC`,
	"muted": `issue_muted__8H97o`,
	"error": `issue_error__5ncmb`,
	"loadingContainer": `issue_loadingContainer__4vwQT`,
	"spinner": `issue_spinner__QgaCa`,
	"spin": `issue_spin__bPIL4`
};
export default ___CSS_LOADER_EXPORT___;
